import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import combineReducers from './combineReducers';
import {loadState, saveState} from './localStorage';

const persistedState = loadState();

let store;
if (!process.env.production) {
    store = createStore(
        combineReducers,
        persistedState,
        compose(
            applyMiddleware(thunk),
            window.__REDUX_DEVTOOLS_EXTENSION__
                ? window.__REDUX_DEVTOOLS_EXTENSION__()
                : noop => noop
        )
    );
} else {
    store = createStore(
        combineReducers,
        persistedState,
        applyMiddleware(thunk)
    );
}
store.subscribe(() => {
    saveState({
        auth: store.getState().auth
    });
});

export default store;
